import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}



const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '首页'
          }
        }, {
          path: '/product',
          name: 'product',
          component: resolve => require(['@/view/product?productType=Auxiliaries'], resolve),
          meta: {
            title: '软件产品'
          },
          children: [
            {
              path: '/product',
              name: 'product',
              component: resolve => require(['@/view/product?productType=Auxiliaries'], resolve),
              meta: {
                title: '产品'
              }
            },
            {
              path: '/product',
              name: 'Agricultural',
              component: resolve => require(['@/view/product'], resolve),
              meta: {
                title: '农业化学助剂'
              }
            },
            {
              path: '/product',
              name: 'Paint',
              component: resolve => require(['@/view/product'], resolve),
              meta: {
                title: '油漆和涂料助剂'
              }
            },
            {
              path: '/product',
              name: 'Auxiliaries',
              component: resolve => require(['@/view/product'], resolve),
              meta: {
                title: '纺织助剂'
              }
            },
            {
              path: '/product',
              name: 'CuttingFluid',
              component: resolve => require(['@/view/product'], resolve),
              meta: {
                title: '金属切削液助剂'
              }
            },
          ]
        }, {
          path: '/companyintroduction',
          name: 'companyintroduction',
          component: resolve => require(['@/view/CompanyIntroduction'], resolve),
          meta: {
            title: '公司介绍'
          }
        }, {
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: '联系我们'
          }
        }, {
          path: '/companyDynamics',
          name: 'companyDynamics',
          component: resolve => require(['@/view/companyDynamics'], resolve),
          meta: {
            title: '公司动态'
          }
        },
        {
          path: '/productDetails',
          name: 'productDetails',
          component: resolve => require(['@/view/productDetails'], resolve),
          meta: {
            title: '产品详情'
          }
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  document.body.scrollTop = 0
  // firefox
  document.documentElement.scrollTop = 0
  next()
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js